import React from 'react';
import QuestionItem, { Question } from './QuestionItem';
import './QuestionContent.css';

export interface QuestionContentProps {
    content?: string;
    questions: Question[];
}

const QuestionContent: React.FC<QuestionContentProps> = ({ content, questions }) => {
    return (
        <div className="question-content-container">
            {Array.isArray(questions) ? (
                questions.map((question, index) => (
                    <QuestionItem
                        key={index}
                        question={question}
                        questionIndex={index}
                    />
                ))
            ) : (
                <div className="content-item">
                    <p className="question-text">Questions in old format - please regenerate</p>
                </div>
            )}
        </div>
    );
};

export default QuestionContent; 